import { render, staticRenderFns } from "./Effector.vue?vue&type=template&id=56b6c1c3&scoped=true&"
import script from "./Effector.vue?vue&type=script&lang=js&"
export * from "./Effector.vue?vue&type=script&lang=js&"
import style0 from "./Effector.vue?vue&type=style&index=0&id=56b6c1c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b6c1c3",
  null
  
)

export default component.exports